var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgExternalLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  color: "#7B7B7B",
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.5 6a.5.5 0 0 1 1 0h-1ZM6 2.5a.5.5 0 0 1 0 1v-1Zm-.646 4.854a.5.5 0 1 1-.708-.708l.708.708ZM11 .5a.5.5 0 0 1 .5.5v4.5a.5.5 0 0 1-1 0v-4h-4a.5.5 0 0 1 0-1H11ZM1.5 4v6h-1V4h1Zm.5 6.5h6v1H2v-1Zm6.5-.5V6h1v4h-1ZM6 3.5H2v-1h4v1ZM4.646 6.646l6-6 .708.708-6 6-.708-.708ZM1.5 10a.5.5 0 0 0 .5.5v1A1.5 1.5 0 0 1 .5 10h1Zm-1-6A1.5 1.5 0 0 1 2 2.5v1a.5.5 0 0 0-.5.5h-1ZM8 10.5a.5.5 0 0 0 .5-.5h1A1.5 1.5 0 0 1 8 11.5v-1Z",
  fill: "currentcolor"
})));
export default SvgExternalLink;